<template>
  <main>
    <section class="admin-page">
      <div class="admin-toolbar">
        <v-text-field
          prepend-inner-icon="mdi-magnify"
          solo
          flat
          dense
          hide-details
          placeholder="Buscar log..."
          background-color="surface_tertiary"
          v-model="filtro_texto"
          class="admin-search"
        />
      </div>
      <div class="admin-table-wrapper">
        <DataTables
          v-if="logs"
          tab="log"
          :data="filteredLogs"
          :fetchData="fetchData"
          :headers="headers"
        />
      </div>
    </section>
  </main>
</template>

<script>
import DataTables from "../components/DataTables.vue";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "LogView",
  components: { DataTables },
  data() {
    return {
      page: 1,
      size: 20,
      filtro_texto: "",
      dsc_login_log: "",
      headers: [
        {
          align: "start",
          sortable: false,
          class: " subtitle-1 font-weight-bold",
          value: "name",
        },
        {
          text: "Usuário",
          sortable: false,
          name: "user",
          class: " subtitle-1 font-weight-bold",
          value: "name",
        },
        {
          text: "Tabela",
          sortable: false,
          name: "table",
          class: " subtitle-1 font-weight-bold",
          value: "name",
        },
        {
          text: "Coluna",
          sortable: false,
          name: "column",
          class: " subtitle-1 font-weight-bold",
          value: "name",
        },
        {
          text: "Valor Anterior",
          sortable: false,
          name: "previous_value",
          class: " subtitle-1 font-weight-bold",
          value: "name",
        },
        {
          text: "Valor Novo",
          sortable: false,
          name: "new_value",
          class: " subtitle-1 font-weight-bold",
          value: "name",
        },
        {
          text: "Operação",
          sortable: false,
          name: "operation",
          class: " subtitle-1 font-weight-bold",
          value: "name",
        },
      ],
    };
  },
  async created() {
    await this.fetchData();
  },
  computed: {
    ...mapGetters({
      logs: "logs/getterLogs",
    }),
    filteredLogs() {
      if (this.filtro_texto) {
        return this.logs.items.filter((item) => {
          return (
            item.dsc_login_log
              .toLowerCase()
              .includes(this.filtro_texto.toLowerCase()) ||
            item.dsc_operacao_log
              .toLowerCase()
              .includes(this.filtro_texto.toLowerCase())
          );
        });
      }
      return this.logs.items;
    },
  },
  methods: {
    ...mapActions({
      getLogs: "logs/getLogs",
    }),
    async fetchData() {
      try {
        await this.getLogs({
          page: this.page,
          size: this.size,
          dsc_excecao: this.dsc_login_log,
        });
      } catch (error) {
        this.$toast.error("Erro ao buscar logs.");
      }
    },
  },
};
</script>

